import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, Mail, ChevronDown, ChevronRight, User, Search } from "lucide-react";
import { SITE_INFO } from "@/data/siteData";
import { CLOAKED_MODE, isPathAllowed } from "@/config/cloakedMode";
import GlobalSearch from "@/components/GlobalSearch";

const NAV_ITEMS = [
  {
    label: "Chi Siamo", path: "/chi-siamo",
    sub: [
      { label: "Il Nostro Impegno", path: "/chi-siamo/impegno-politico" },
      { label: "Organismi", path: "/chi-siamo/organismi" },
      { label: "Statuto e Regolamenti", path: "/chi-siamo/statuto-e-regolamenti" },
      { label: "Associazioni", path: "/associazioni" },
      { label: "Promo.Ter", path: "/chi-siamo/enti-collegati/promo-ter" },
      { label: "C.A.T. Confcommercio Roma", path: "/chi-siamo/cat" },
      { label: "Partner", path: "/chi-siamo/partner" },
      { label: "Trasparenza", path: "/chi-siamo/trasparenza" },
      { label: "Struttura Tecnica", path: "/chi-siamo/struttura-tecnica" },
    ],
  },
  // { label: "Chi Siamo B", path: "/chi-siamo-b" },
  {
    label: "Area Lavoro e Welfare", path: "/area-lavoro-welfare",
    sub: [
      { label: "Cosa offriamo", path: "/area-lavoro-welfare/servizi" },
      { label: "Trasparenza salariale", path: "/area-lavoro-welfare/trasparenza-salariale" },
      { label: "Contrattazione collettiva", path: "/area-lavoro-welfare/contrattazione-collettiva" },
      { label: "Flessibilità organizzativa", path: "/area-lavoro-welfare/flessibilita-organizzativa" },
      { label: "Welfare aziendale", path: "/area-lavoro-welfare/welfare-aziendale" },
      { label: "Assunzioni agevolate", path: "/area-lavoro-welfare/assunzioni-agevolate" },
      { label: "Contenzioso sul lavoro", path: "/area-lavoro-welfare/contenzioso-lavoro" },
      { label: "Certificazioni per le imprese", path: "/area-lavoro-welfare/parita-genere" },
    ],
  },
  {
    label: "Servizi", path: "/servizi",
    sub: [
      { label: "Servizi inclusi nella quota", path: "/servizi#quota", sub: [
        { label: "Consulenza sul lavoro e welfare",                            path: "/servizi/consulenza-lavoro-welfare" },
        { label: "Consulenza legale e legislativa",                            path: "/servizi/consulenza-legale" },
        { label: "Check-up tecnico-amministrativo",                            path: "/servizi/check-up-tecnico-amministrativo" },
        { label: "Rating di Legalità",                                         path: "/servizi/rating-legalita" },
        { label: "Check-up Tecnico Adempimenti Normativi",                     path: "/servizi/check-up-adempimenti-normativi" },
        { label: "Supporto pubblicazione contributi pubblici",                 path: "/servizi/contributi-pubblici" },
      ]},
      { label: "Servizi di assistenza per l'impresa", path: "/servizi#assistenza", sub: [
        { label: "Sicurezza sul lavoro",                                       path: "/servizi/sicurezza-lavoro" },
        { label: "Sorveglianza sanitaria",                                     path: "/servizi/sorveglianza-sanitaria" },
        { label: "Sicurezza nei cantieri",                                     path: "/servizi/sicurezza-cantieri" },
        { label: "Indagini Ambientali",                                        path: "/servizi/indagini-ambientali" },
        { label: "Igiene degli alimenti H.A.C.C.P.",                          path: "/servizi/igiene-alimenti-haccp" },
        { label: "Privacy e GDPR",                                             path: "/servizi/privacy-gdpr" },
        { label: "Certificazioni di Qualità e Sistemi di Gestione",           path: "/servizi/certificazioni-qualita" },
        { label: "Certificazione ESG",                                         path: "/servizi/certificazione-esg" },
        { label: "Certificazione Modello 231",                                 path: "/servizi/modello-231" },
        { label: "Business Plan",                                              path: "/servizi/business-plan" },
        { label: "Patente a Crediti Cantieri",                                 path: "/servizi/patente-crediti-cantieri" },
        { label: "Gestione dei rifiuti",                                       path: "/servizi/gestione-rifiuti" },
        { label: "Check-up Digitale & AI per le PMI",                          path: "/servizi/check-up-digitale-ai" },
        { label: "Finanza Agevolata e Bandi per le Imprese",                   path: "/servizi/finanza-agevolata-bandi" },
      ]},
    ],
  },
  {
    label: "Formazione", path: "/formazione",
    sub: [
      { label: "Calendario Corsi",                                                                path: "/formazione/corsi-in-partenza" },
      { label: "Formazione Finanziata per le Aziende del Terziario",                             path: "/formazione/formazione-finanziata" },
      { label: "Contratto di Apprendistato",                                                     path: "/formazione/apprendistato" },
      { label: "Formazione di aggiornamento e specializzazione",                                    path: "/formazione/aggiornamento-specializzazione" },
      { label: "Formazione Abilitante e Progetti Speciali",                                       path: "/formazione/formazione-abilitante" },
      { label: "Formazione Obbligatoria",                                                        path: "/formazione/formazione-obbligatoria" },
      { label: "Formazione a Distanza (FAD)",                                                    path: "/formazione/formazione-a-distanza" },
      { label: "Formazione Personalizzata Finanziata con il Fondo For.Te e FONDIR",              path: "/formazione/formazione-personalizzata" },
    ],
  },
  { label: "Ricerca e Progetti", path: "/ricerca-e-progetti",
    sub: [
      { label: "Progetti", path: "/progetti" },
      { label: "L'Osservatorio Economico", path: "/osservatorio-economico" },
      { label: "Le Bussole Confcommercio", path: "/le-bussole" },
    ],
  },
  { label: "Convenzioni", path: "/convenzioni" },
  {
    label: "Novità", path: "/notizie",
    sub: [
      { label: "Notizie", path: "/notizie" },
      { label: "Appuntamenti", path: "/eventi" },
    ],
  },
  {
    label: "Contatti", path: "/contatti",
    sub: [
      { label: "Lavora con noi", path: "/contatti/lavora-con-noi" },
    ],
  },
  { label: "Associati ora", path: "/associati-ora", highlight: true },
];

// In cloaked mode: filtra la lista mostrando solo le voci accessibili
function filterNavForCloaked(items) {
  if (!CLOAKED_MODE) return items;
  return items
    .map((item) => {
      const subFiltered = item.sub
        ? item.sub
            .map((s2) => {
              const s3Filtered = s2.sub
                ? s2.sub.filter((s3) => isPathAllowed(s3.path.split("#")[0]))
                : undefined;
              const s2Allowed = isPathAllowed(s2.path.split("#")[0]);
              if (s3Filtered && s3Filtered.length > 0) {
                return { ...s2, sub: s3Filtered };
              }
              if (s2Allowed && (!s2.sub || s2.sub.length === 0)) {
                return { ...s2, sub: undefined };
              }
              return null;
            })
            .filter(Boolean)
        : undefined;
      const itemAllowed = isPathAllowed(item.path.split("#")[0]);
      if (subFiltered && subFiltered.length > 0) {
        return { ...item, sub: subFiltered };
      }
      if (itemAllowed && (!item.sub || item.sub.length === 0)) {
        return { ...item, sub: undefined };
      }
      return null;
    })
    .filter(Boolean);
}


export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openSubDropdown, setOpenSubDropdown] = useState(null);
  const location = useLocation();

  const navItems = filterNavForCloaked(NAV_ITEMS);

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    const [pathname, hash] = path.split("#");
    if (hash) return location.pathname === pathname && location.hash === `#${hash}`;
    return location.pathname.startsWith(pathname);
  };

  const isSubActive = (path) => {
    const [pathname, hash] = path.split("#");
    if (hash) return location.pathname === pathname && location.hash === `#${hash}`;
    return location.pathname === pathname;
  };

  // L2 attivo se coincide con il path corrente OPPURE se un suo figlio L3 è attivo
  const isL2Active = (sub) => {
    if (isSubActive(sub.path)) return true;
    if (sub.sub) return sub.sub.some(s3 => location.pathname === s3.path || location.pathname.startsWith(s3.path + "/"));
    return false;
  };

  return (
    <>
      {/* Top bar - fixed */}
      <div className="bg-[var(--confcom-blue)] text-white text-sm fixed top-0 left-0 right-0 z-[60]" role="banner">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center gap-4 h-10">
          <div className="flex items-center gap-6 shrink-0">
            <a href={`tel:${SITE_INFO.phone}`} className="flex items-center gap-1.5 hover:underline" data-testid="topbar-phone">
              <Phone size={14} aria-hidden="true" />
              <span className="hidden sm:inline">{SITE_INFO.phone}</span>
            </a>
            <a href={`mailto:${SITE_INFO.email}`} className="flex items-center gap-1.5 hover:underline" data-testid="topbar-email">
              <Mail size={14} aria-hidden="true" />
              <span className="hidden md:inline">{SITE_INFO.email}</span>
            </a>
          </div>

          <div className="flex items-center gap-2 sm:gap-3 ml-auto shrink-0">
            {/* Marketplace e Area Riservata — bozza: oscurati dal frontend su richiesta utente, ripubblicare rimuovendo il commento
            {!CLOAKED_MODE && (
              <>
                <Link to="/marketplace" className="hidden md:flex items-center gap-1.5 bg-white/15 hover:bg-white/25 px-3 py-1 rounded-md font-medium transition-colors">
                  Marketplace
                </Link>
                <Link
                  to="/area-riservata"
                  className="flex items-center gap-1.5 bg-white/10 hover:bg-white/20 px-3 py-1 rounded-md transition-colors"
                  data-testid="topbar-area-riservata"
                >
                  <User size={14} aria-hidden="true" />
                  <span>Area Riservata</span>
                </Link>
              </>
            )}
            */}
          </div>
        </div>
      </div>

      {/* Riga 1 — Loghi (Confcommercio + Promo.Ter + C.A.T.) + ricerca (desktop) / hamburger (mobile), sticky sotto la topbar */}
      <div className="bg-white sticky top-10 z-50" data-testid="navbar-logo-row">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 lg:h-20">
          <Link to="/" className="flex items-center shrink-0 min-w-0" data-testid="navbar-logo" aria-label="Confcommercio Roma, Promo.Ter, C.A.T. - Torna alla homepage">
            <img
              src="/local-assets/logo-confcom-promoter-cat.png"
              alt="Confcommercio Roma, Promo.Ter, C.A.T."
              className="w-[264px] sm:w-[340px] lg:w-auto h-auto lg:h-12 max-w-full"
            />
          </Link>
          <div className="hidden lg:block w-[259px]" data-testid="logo-row-search-wrap">
            <GlobalSearch
              variant="compact"
              placeholder="Cerca nel sito…"
              testId="logo-row-search"
            />
          </div>
          {/* Mobile toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden p-2 rounded-md text-[var(--confcom-text-secondary)] hover:bg-[var(--confcom-bg-blue-light)]"
            aria-label={mobileOpen ? "Chiudi menu" : "Apri menu"}
            aria-expanded={mobileOpen}
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Riga 2 — Menu di navigazione desktop (sticky sotto la riga loghi, nascosto su mobile) */}
      <header className="hidden lg:block bg-white border-b border-[var(--confcom-border)] sticky lg:top-[120px] z-50" role="navigation">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" aria-label="Navigazione principale">
          <div className="flex items-center justify-between h-12">
            {/* Desktop nav */}
            <div className="flex items-center justify-between w-full" role="menubar">
              <div className="flex items-center gap-1">
              {navItems.filter((item) => !item.highlight).map((item, idx) => (
                <div
                  key={item.path}
                  className="relative"
                  onMouseEnter={() => item.sub && setOpenDropdown(item.label)}
                  onMouseLeave={() => setOpenDropdown(null)}
                >
                  <Link
                    to={item.path}
                    className={`${idx === 0 ? "pl-0 pr-6" : "px-6"} py-2 text-sm font-medium rounded-md transition-colors flex items-center gap-1 whitespace-nowrap ${
                      isActive(item.path)
                        ? "text-[var(--confcom-blue)] bg-[var(--confcom-bg-blue-light)]"
                        : "text-[var(--confcom-text-secondary)] hover:text-[var(--confcom-blue)] hover:bg-[var(--confcom-bg-blue-light)]"
                    }`}
                    data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                    role="menuitem"
                    aria-haspopup={item.sub ? "true" : undefined}
                    aria-expanded={openDropdown === item.label ? "true" : undefined}
                  >
                    {item.label}
                    {item.sub && <ChevronDown size={14} aria-hidden="true" />}
                  </Link>
                  {item.sub && openDropdown === item.label && (
                    <div className="absolute top-full left-0 pt-2 z-50" role="menu">
                      <div className="w-64 bg-white border border-[var(--confcom-border)] rounded-lg shadow-lg py-2">
                      {item.sub.map((sub) => (
                        sub.sub ? (
                          /* L2 item con flyout L3 */
                          <div
                            key={sub.path}
                            className="relative"
                            onMouseEnter={() => setOpenSubDropdown(sub.label)}
                            onMouseLeave={() => setOpenSubDropdown(null)}
                          >
                            <Link
                              to={sub.path}
                              onClick={() => setOpenDropdown(null)}
                              className={`flex items-center justify-between px-4 py-2.5 text-sm transition-colors ${
                                isL2Active(sub)
                                  ? "text-[var(--confcom-blue)] bg-[var(--confcom-bg-blue-light)] font-semibold"
                                  : "text-[var(--confcom-text-secondary)] hover:text-[var(--confcom-blue)] hover:bg-[var(--confcom-bg-blue-light)]"
                              }`}
                            >
                              <span>{sub.label}</span>
                              <ChevronRight size={13} aria-hidden="true" />
                            </Link>
                            {openSubDropdown === sub.label && (
                              <div className="absolute top-0 left-full pl-1 z-50">
                                <div className="w-72 bg-white border border-[var(--confcom-border)] rounded-lg shadow-lg py-2 max-h-[420px] overflow-y-auto">
                                  {sub.sub.map((s3) => (
                                    <Link
                                      key={s3.path}
                                      to={s3.path}
                                      onClick={() => { setOpenDropdown(null); setOpenSubDropdown(null); }}
                                      className={`block px-4 py-2.5 text-sm transition-colors ${
                                        isSubActive(s3.path)
                                          ? "text-[var(--confcom-blue)] bg-[var(--confcom-bg-blue-light)] font-semibold"
                                          : "text-[var(--confcom-text-secondary)] hover:text-[var(--confcom-blue)] hover:bg-[var(--confcom-bg-blue-light)]"
                                      }`}
                                      data-testid={`nav-sub3-${s3.label.toLowerCase().replace(/\s/g, "-")}`}
                                    >
                                      {s3.label}
                                    </Link>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          /* L2 item normale */
                          <Link
                            key={sub.path}
                            to={sub.path}
                            onClick={() => setOpenDropdown(null)}
                            className={`block px-4 py-2.5 text-sm transition-colors ${
                              isSubActive(sub.path)
                                ? "text-[var(--confcom-blue)] bg-[var(--confcom-bg-blue-light)] font-semibold"
                                : "text-[var(--confcom-text-secondary)] hover:text-[var(--confcom-blue)] hover:bg-[var(--confcom-bg-blue-light)]"
                            }`}
                            role="menuitem"
                            data-testid={`nav-sub-${sub.label.toLowerCase().replace(/\s/g, "-")}`}
                          >
                            {sub.label}
                          </Link>
                        )
                      ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
              </div>

              {navItems.filter((item) => item.highlight).map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="pl-6 pr-3 py-2 text-sm font-medium rounded-md transition-colors flex items-center gap-1 whitespace-nowrap bg-[var(--confcom-blue)] text-white hover:bg-[var(--confcom-blue-dark)]"
                  data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                  role="menuitem"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </nav>
      </header>

      {/* Mobile menu drawer (fuori dall'header nascosto su mobile, fixed sotto la riga loghi) */}
      {mobileOpen && (
        <div className="lg:hidden fixed top-[104px] inset-x-0 z-40 border-t border-[var(--confcom-border)] bg-white max-h-[calc(100vh-104px)] overflow-y-auto" role="menu" data-testid="mobile-menu">
          {/* Ricerca mobile */}
          <div className="px-4 pt-4" data-testid="mobile-menu-search-wrap">
            <GlobalSearch
              variant="compact"
              placeholder="Cerca nel sito…"
              testId="mobile-menu-search"
              onNavigate={() => setMobileOpen(false)}
            />
          </div>

          {/* Quick links mobile — Marketplace e Area Riservata: bozza, oscurati dal frontend
          {!CLOAKED_MODE && (
            <div className="px-4 pt-3 pb-2 grid grid-cols-2 gap-2">
              <Link to="/marketplace" onClick={() => setMobileOpen(false)} className="flex flex-col items-center gap-1 p-3 rounded-xl bg-[var(--confcom-bg-blue-light)] text-center">
                <span className="text-xs font-semibold text-[var(--confcom-blue)]">Marketplace</span>
              </Link>
              <Link to="/area-riservata" onClick={() => setMobileOpen(false)} className="flex flex-col items-center gap-1 p-3 rounded-xl bg-[var(--confcom-bg-blue-light)] text-center">
                <span className="text-xs font-semibold text-[var(--confcom-blue)]">Area Riservata</span>
              </Link>
            </div>
          )}
          */}

          <div className="px-4 py-3 space-y-1">
            {navItems.map((item) => (
              <div key={item.path}>
                {item.sub ? (
                  <button
                    onClick={() => setOpenDropdown(openDropdown === item.label ? null : item.label)}
                    className={`w-full flex items-center justify-between px-4 py-3 rounded-md text-sm font-semibold transition-colors ${
                      isActive(item.path)
                        ? "text-[var(--confcom-blue)] bg-[var(--confcom-bg-blue-light)]"
                        : "text-[var(--confcom-text-primary)] hover:bg-gray-50"
                    }`}
                  >
                    {item.label}
                    <ChevronDown size={16} className={`transition-transform ${openDropdown === item.label ? "rotate-180" : ""}`} />
                  </button>
                ) : (
                  <Link
                    to={item.path}
                    onClick={() => setMobileOpen(false)}
                    className={`block px-4 py-3 rounded-md text-sm font-semibold transition-colors ${
                      item.highlight
                        ? "text-white bg-[var(--confcom-blue)]"
                        : isActive(item.path)
                          ? "text-[var(--confcom-blue)] bg-[var(--confcom-bg-blue-light)]"
                          : "text-[var(--confcom-text-primary)] hover:bg-gray-50"
                    }`}
                  >
                    {item.label}
                  </Link>
                )}
                {item.sub && openDropdown === item.label && (
                  <div className="ml-4 mt-1 mb-2 space-y-0.5 border-l-2 border-[var(--confcom-bg-blue-light)] pl-3">
                    <Link
                      to={item.path}
                      onClick={() => setMobileOpen(false)}
                      className="block px-3 py-2 text-sm text-[var(--confcom-blue)] font-medium"
                    >
                      Panoramica
                    </Link>
                    {item.sub.map((sub) => (
                      <div key={sub.path}>
                        {sub.sub ? (
                          <>
                            <button
                              onClick={() => setOpenSubDropdown(openSubDropdown === sub.label ? null : sub.label)}
                              className="w-full flex items-center justify-between px-3 py-2 text-sm text-[var(--confcom-text-secondary)] hover:text-[var(--confcom-blue)]"
                            >
                              {sub.label}
                              <ChevronDown size={13} className={`transition-transform ${openSubDropdown === sub.label ? "rotate-180" : ""}`} />
                            </button>
                            {openSubDropdown === sub.label && (
                              <div className="ml-3 border-l border-[var(--confcom-border)] pl-3 space-y-0.5 mb-1">
                                {sub.sub.map((s3) => (
                                  <Link
                                    key={s3.path}
                                    to={s3.path}
                                    onClick={() => setMobileOpen(false)}
                                    className="block px-3 py-2 text-sm text-[var(--confcom-text-secondary)] hover:text-[var(--confcom-blue)]"
                                  >
                                    {s3.label}
                                  </Link>
                                ))}
                              </div>
                            )}
                          </>
                        ) : (
                          <Link
                            to={sub.path}
                            onClick={() => setMobileOpen(false)}
                            className={`block px-3 py-2 text-sm transition-colors ${
                              isSubActive(sub.path)
                                ? "text-[var(--confcom-blue)] font-semibold"
                                : "text-[var(--confcom-text-secondary)] hover:text-[var(--confcom-blue)]"
                            }`}
                          >
                            {sub.label}
                          </Link>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
